import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Col, Row, Tag} from "antd";

class CheckableTagList extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    _handleTagChange(checked,value) {
        this.props.onChange && this.props.onChange.call(this, checked,value);
    }

    render() {

        const dataList = this.props.dataList ? this.props.dataList : []; //显示数据列表
        const value = this.props.value ; //改变数据的列表
        const spaceFlag = this.props.space ? this.props.space : false; //间距样式，默认false
        const multiple = this.props.multiple ? this.props.multiple : true; //设置多选或单选，默认true，多选
        let space = {span1: 6, span2: 18, span3: 3, span4: 21};
        if (spaceFlag) {
            space = {span1: 3, span2: 21, span3: 1, span4: 23};
        }

        return (
            <div>
                {this.props.hasUnlimit ?
                    <Tag.CheckableTag
                        key={-1}
                        checked={!value||value.length === 0}
                        onChange={checked => this._handleTagChange(checked, "-1")}
                    >不限
                    </Tag.CheckableTag> : null}

                {
                    dataList.map((item, index) => {

                        return (
                            <Tag.CheckableTag
                                key={index}
                                checked={multiple ? value&&value.includes(item.value) : value === item.value}
                                onChange={checked => this._handleTagChange(checked,item.value)}
                            >{item.label}
                            </Tag.CheckableTag>
                        )
                    })
                }


    </div>
    )
        ;
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(CheckableTagList);